// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp, Transition, TransitionGroup } from 'vue'
import Vue from '@vue/compat';

import registerBootstrapControls from './ui/bootstrap.js';
// import BootstrapVueNext from 'bootstrap-vue-next';
// import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import { i18n, changeLocalization } from './i18n';

//// import {BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import veProgress from 'vue-ellipse-progress';
//// import VeeValidate from 'vee-validate';

// import the component and styles
import Treeselect from "@zanmato/vue3-treeselect";
import "@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css";

import App from './App';
// import VueCookies from 'vue3-cookies';
import { globalCookiesConfig } from "vue3-cookies";

globalCookiesConfig({
  expireTimes: "30d",
  path: "/",
  domain: "",
  secure: true,
  sameSite: "None",
});
import log from '@/services/Logger';

import router from './router';
import store from './store';

import CustomFilter from '@/plugins/CustomFilter';
import dayjsPlugin from '@/plugins/dayjs';

import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import AuthenticationService from '@/services/AuthenticationService';
import EventBus from '@/services/EventBus.js';

Vue.use(CustomFilter);

Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.configureCompat({
  MODE: 3, // Strict Vue 3 mode - all Vue 2 features disabled

  // Global API
  GLOBAL_MOUNT: false,
  GLOBAL_EXTEND: false,
  GLOBAL_PROTOTYPE: false,
  GLOBAL_SET: false,
  GLOBAL_DELETE: false,
  GLOBAL_OBSERVABLE: false,

  // Config
  CONFIG_KEY_CODES: false,
  CONFIG_WHITESPACE: false,

  // Component
  COMPONENT_V_MODEL: false,
  COMPONENT_FUNCTIONAL: false,

  // Render Function
  RENDER_FUNCTION: false,

  // Filters
  FILTERS: false,

  // Instance
  INSTANCE_SET: false,
  INSTANCE_DELETE: false,
  INSTANCE_DESTROY: false,
  INSTANCE_EVENT_EMITTER: false,
  INSTANCE_EVENT_HOOKS: false,
  INSTANCE_CHILDREN: false,
  INSTANCE_LISTENERS: false,
  INSTANCE_SCOPED_SLOTS: false,
  INSTANCE_ATTRS_CLASS_STYLE: false,

  // Options
  OPTIONS_DATA_FN: false,
  OPTIONS_DATA_MERGE: false,
  OPTIONS_BEFORE_DESTROY: false,
  OPTIONS_DESTROYED: false,

  // Watch
  WATCH_ARRAY: false,

  // v-on
  V_ON_KEYCODE_MODIFIER: false,

  // Transition
  TRANSITION_CLASSES: false,
  TRANSITION_GROUP_ROOT: false,

  // Compiler
  COMPILER_V_IF_V_FOR_PRECEDENCE: false,
  COMPILER_V_BIND_SYNC: false,
  COMPILER_V_BIND_PROP: false,
  COMPILER_V_BIND_OBJECT_ORDER: false,
  COMPILER_V_ON_NATIVE: false,
  COMPILER_V_FOR_REF: false,
  COMPILER_NATIVE_TEMPLATE: false,
  COMPILER_INLINE_TEMPLATE: false,
  COMPILER_FILTERS: false,

  // Custom Elements
  CUSTOM_DIR: false,

  // Attr Fallthrough
  ATTR_FALSE_VALUE: false,
  ATTR_ENUMERATED_COERCION: false,
});

// Set AG Grid License, Version 23 und 8 für die Charts sind vorhanden ... alle Versionen bis Ende 2023 schätze ich
import {LicenseManager} from "ag-grid-enterprise";
LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID);

let highestZIndex = 100, activeDraggable = null;
Vue.directive('draggable', {
  bind: function (el) {
    var startX, startY, initialMouseX, initialMouseY;

    // Give all components a different zIndex
    el.style.zIndex = highestZIndex++;
    el.style.position = 'absolute';

    function mousemove(e) {
      if ((e.clientX >= 10) && (e.clientX <= window.innerWidth - 10)) {
        var dx = e.clientX - initialMouseX;
        el.style.left = startX + dx + 'px';
      }
      if ((e.clientY >= 50) && (e.clientY <= window.innerHeight - 50)) {
        var dy = e.clientY - initialMouseY;
        el.style.top = startY + dy + 'px';

      }
      return false;
    }

    function mouseup() {
      document.body.classList.remove("disable-text-selection");
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
    }

    el.children[0].addEventListener('mousedown', function (e) {
      document.body.classList.add("disable-text-selection");

      startX = el.offsetLeft;
      startY = el.offsetTop;
      initialMouseX = e.clientX;
      initialMouseY = e.clientY;
      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
      return false;
    });

    // Draggable elements will stay in visible part while resizing
    window.addEventListener("resize", function () {
      if (el.style.left != "") {
        if (window.innerWidth < parseInt(el.style.left) + 40) {
          el.style.left = (window.innerWidth - 60) + "px";
        }
        if ((window.innerHeight < parseInt(el.style.top) + 30) && window.innerHeight > 80) {
          el.style.top = (window.innerHeight - 50) + "px";
        }
      }
    });

    // Set component on top on focus change (click in element)
    el.addEventListener('mousedown', function (e) {
      // Only fire, if another component is clicked
      if (activeDraggable === el)
        return;
      activeDraggable = el;

      // We keep order by just increasing the zIndex
      el.style.zIndex = highestZIndex++;
    });
  },
});

// Set element
EventBus.$on('set-topmost-element', (el) => {
  if ((el instanceof Element) && (el?.style))
    el.style.zIndex = highestZIndex++;
  else
    console.warn('Argument is no DOM element. Type: ', typeof el)
});

function startApp() {
  const app = createApp(App);
  // make in this.$EventBus.$on(...), etc. available in all components
  app.config.globalProperties.$bus = EventBus;
  app.config.globalProperties.$log = log;

  // make globally available in js, e.g. EventBus.$on(...)
  window.EventBus = EventBus;
  window.log = log;
  window._ = require('lodash');

  registerBootstrapControls(app); // app.use(BootstrapVueNext); auto import does not work with Vue 2 compat

  app.component('treeselect', Treeselect);
  app.component('Treeselect', Treeselect);
  app.component('TreeSelect', Treeselect);

  app.component('font-awesome-icon', FontAwesomeIcon);
  app.component('font-awesome-layers', FontAwesomeLayers);
  app.component('font-awesome-layers-text', FontAwesomeLayersText);

  app.use(dayjsPlugin);

  app.use(veProgress);
  app.use(router);
  app.use(store);
  app.use(i18n);
  // app.use(VueCookies);


  app.mount('#app');
}

changeLocalization('en-GB').then(_ => { startApp(); }).catch(_ => { startApp(); });

const applyDefaultStyle = () => {
  // Custom CI f BMW Motorrad, bei gleicher Plattform
  // Sonderlocke für BMW Motorrad
  if (APP_TARGET === "bmw") {
    if (window.location.hostname.includes("bmwmotorrad")) {
      return import('@/scss/style-bmwmotorrad.scss').then(() => {});
    } else {
      return import('@/scss/style-bmw.scss').then(() => {});
    }
  }

  // Default
  if (APP_TARGET) {
    return import(`@/scss/style-${APP_TARGET}.scss`).then(() => {});
  } else {
    return import('@/scss/style.scss').then(() => {});
  }
};

let styleHook = router.beforeEach((to, from, next) => {
  // Unregister hook
  styleHook();

  // Use customized theme if generic platform and authenticated client user
  if (APP_TARGET === '' && AuthenticationService.isAuthenticated &&
      !AuthenticationService.isMSMUser && AuthenticationService.localUserProfile.ClientId)
  {
    let stylesheetLink = document.createElement('link');
    stylesheetLink.rel = 'stylesheet';
    stylesheetLink.href = `${process.env.BASE_URL}api/users/css?clientId=${AuthenticationService.localUserProfile.ClientId}`;
    stylesheetLink.onload = next;
    stylesheetLink.onerror = () => {
      applyDefaultStyle().then(() => {
        next();
      });
    };
    document.head.appendChild(stylesheetLink);
  }
  else {
    applyDefaultStyle().then(() => {
      next();
    });
  }
});

// ResizeObserver Error unterdrücken (harmlos, tritt bei schnellen Größenänderungen auf)
window.addEventListener('error', (e) => {
  if (
    e.message.includes('ResizeObserver loop limit exceeded') ||
    e.message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) {
      resizeObserverErr.style.display = 'none';
    }
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});

// Zusätzlich: Unhandled Error Handler
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const resizeObserverErrorHandler = debounce((e) => {
  if (
    e.message &&
    (e.message.includes('ResizeObserver') ||
     e.reason?.message?.includes('ResizeObserver'))
  ) {
    e.stopImmediatePropagation();
    return true;
  }
  return false;
}, 100);

window.addEventListener('unhandledrejection', (e) => {
  resizeObserverErrorHandler(e);
});
